import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel, AllocationViewArrivalDockModel } from '../../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AllocationViewArriveAtDockConfirmationActionService {
  constructor(private http: WrapperHttpService) {}

  arriveAtDockConfirmation(data: AllocationViewArrivalDockModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Dock}${AllocationViewEndpoint.ArrivalConfirmation}`;

    return this.http.withLoading().post<void>(url, data);
  }

  arriveAtDockConfirmationPrepare(
    actionIdentifier: AllocationViewActionIdentifierModel,
    currentLanguage: string,
  ): Observable<AllocationViewArrivalDockModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Dock}${AllocationViewEndpoint.ArrivalConfirmation}${AllocationViewEndpoint.Prepare}?lang=${currentLanguage}`;

    return this.http.withLoading().post<AllocationViewArrivalDockModel>(url, actionIdentifier);
  }
}
